import { render, staticRenderFns } from "./IconShieldCheck.vue?vue&type=template&id=72fa9210"
import script from "./IconShieldCheck.vue?vue&type=script&lang=js"
export * from "./IconShieldCheck.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports